export const CREATE_APPOINTMENT_REQUEST =
  "APPOINTMENT.CREATE_APPOINTMENT_REQUEST";
export const CREATE_APPOINTMENT_SUCCESS =
  "APPOINTMENT.CREATE_APPOINTMENT_SUCCESS";
export const CREATE_APPOINTMENT_FAILURE =
  "APPOINTMENT.CREATE_APPOINTMENT_FAILURE";

export const GET_MY_APPOINTMENT_REQUEST =
  "APPOINTMENT.GET_MY_APPOINTMENT_REQUEST";
export const GET_MY_APPOINTMENT_SUCCESS =
  "APPOINTMENT.GET_MY_APPOINTMENT_SUCCESS";
export const GET_MY_APPOINTMENT_FAILURE =
  "APPOINTMENT.GET_MY_APPOINTMENT_FAILURE";

export const GET_DOCTOR_APPOINTMENT_REQUEST =
  "APPOINTMENT.GET_DOCTOR_APPOINTMENT_REQUEST";
export const GET_DOCTOR_APPOINTMENT_SUCCESS =
  "APPOINTMENT.GET_DOCTOR_APPOINTMENT_SUCCESS";
export const GET_DOCTOR_APPOINTMENT_FAILURE =
  "APPOINTMENT.GET_DOCTOR_APPOINTMENT_FAILURE";

export const UPDATE_APPOINTMENT_REQUEST =
  "APPOINTMENT.UPDATE_APPOINTMENT_REQUEST";
export const UPDATE_APPOINTMENT_SUCCESS =
  "APPOINTMENT.UPDATE_APPOINTMENT_SUCCESS";
export const UPDATE_APPOINTMENT_FAILURE =
  "APPOINTMENT.UPDATE_APPOINTMENT_FAILURE";

export const GET_DETAIL_APPOINTMENT_REQUEST =
  "APPOINTMENT.GET_DETAIL_APPOINTMENT_REQUEST";
export const GET_DETAIL_APPOINTMENT_SUCCESS =
  "APPOINTMENT.GET_DETAIL_APPOINTMENT_SUCCESS";
export const GET_DETAIL_APPOINTMENT_FAILURE =
  "APPOINTMENT.GET_DETAIL_APPOINTMENT_FAILURE";

export const UPDATE_STATUS_APPOINTMENT_REQUEST =
  "APPOINTMENT.UPDATE_STATUS_APPOINTMENT_REQUEST";
export const UPDATE_STATUS_APPOINTMENT_SUCCESS =
  "APPOINTMENT.UPDATE_STATUS_APPOINTMENT_SUCCESS";
export const UPDATE_STATUS_APPOINTMENT_FAILURE =
  "APPOINTMENT.UPDATE_STATUS_APPOINTMENT_FAILURE";
